// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridContainer {
  border-radius: 0.6rem;
  border: 1px solid #DCDFE1;
  margin-top: 0.5rem;
}

.priorityContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  border-top: 1px solid #DCDFE1;
  border-bottom: 1px solid #DCDFE1;
  padding: 0.5rem 0;
  margin-top: 0.5rem;
  gap: 0.5rem;
}
.priorityContainer > button {
  max-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/JobGroups/job.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AACF;AACE;EACE,gBAAA;AACJ","sourcesContent":[".gridContainer {\n    border-radius: 0.6rem;\n    border: 1px solid #DCDFE1;\n    margin-top: 0.5rem;\n}\n\n.priorityContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  border-top: 1px solid #DCDFE1;\n  border-bottom: 1px solid #DCDFE1;\n  padding: 0.5rem 0;\n  margin-top: 0.5rem;\n  gap: 0.5rem;\n\n  & > button {\n    max-width: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
